
import { sanitizeJsonLdStrings } from "~/utils/jsonld-sanitize";

export default {
  props: {
    pageTitle: { type: [Array, String], default: () => [] },
    pageType: { type: String, default: "" },
  },

  data: () => ({ breadCrumbs: [] }),

  head() {
    if (!this.breadCrumbs.length) return {};

    const baseUrl = this.$config.appEndPoint;

    const breadcrumbItems = [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: baseUrl,
      },
      ...this.breadCrumbs.map(({ pageTitle, url }, index) => ({
        "@type": "ListItem",
        position: index + 2,
        name: pageTitle,
        item: url ? `${baseUrl}${url}` : `${baseUrl}${this.$route.path}`,
      })),
    ];

    return {
      script: [
        {
          hid: `jsonld-breadcrumb-${this.$route.path}`,
          type: "application/ld+json",
          json: sanitizeJsonLdStrings({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: breadcrumbItems,
          }),
        },
      ],
    };
  },

  /**
   * SSR-SAFE
   * No localStorage, no window, no client-only logic
   */
  created() {
    const pageTitle = this.$prismic.asText(this.pageTitle);

    // Always ensure at least the current page breadcrumb exists for SSR
    this.breadCrumbs = [{ pageTitle }];
  },

  /**
   * CLIENT-ONLY
   * localStorage access lives here
   */
  async mounted() {
    await this.$store.dispatch("app/hydrateRedirectFrom");

    const redirectFrom = this.$store.state.app.redirectFrom;
    const { url } = redirectFrom || {};

    const showPrevBreadCrumbItem =
      (url?.includes("collections") ||
        url?.includes("cart") ||
        url?.includes("store")) &&
      (this.pageType === "Product_detail_page" ||
        this.pageType === "Store_page");

    if (showPrevBreadCrumbItem) {
      this.breadCrumbs = [redirectFrom, ...this.breadCrumbs];
    }
  },
};
